<template>
  <div style="position: relative;">
    <!-- <Modal
      :mask-closable="false"
      :width="'900px'"
      @on-cancel="cancelHis"
      footer-hide
      title="咨询记录"
      v-model="showHis"
    >-->

    <Divider orientation="left">咨询信息</Divider>

    <template v-if="showSimple">
      <div class="chartInfo">
        <table>
          <tbody>
            <tr>
              <td>咨询件编码</td>
              <td>{{group.groupId}}</td>
              <td>咨询类型</td>
              <td>
                <dicLabel :value="group.consultationType" category="CONSULTATION_TYPE"></dicLabel>
              </td>
              <td>状态</td>
              <td>{{$common.IMConsultationStatusMap[group.consultationStatus] || '--'}}</td>
            </tr>
            <tr>
              <td>咨询时间</td>
              <td>{{group.whenCreated}}</td>
              <td>接入时间</td>
              <td>{{group.acceptTime}}</td>
              <td>结束时间</td>
              <td>{{group.closeTime}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </template>
    <template v-else>
      <div class="chartInfo">
        <table>
          <tbody>
            <tr>
              <td>所属区域</td>
              <td>{{ group.areaName }}</td>
              <td>咨询类型</td>
              <td>
                <labelValue
                  :category="'CONSULTATION_TYPE'"
                  :clearable="false"
                  :data="group.consultationType"
                  @change="changeCT"
                  filterable
                  transfer
                ></labelValue>
                <!-- <dicLabel :value="group.consultationType" category="CONSULTATION_TYPE"></dicLabel> -->
              </td>
              <!-- <td>服务主体</td>
              <td>
                <dicLabel :value="group.consultationSubject" category="CONSULTATION_SUBJECT"></dicLabel>
              </td>-->

              <td>状态</td>
              <td>{{$common.IMConsultationStatusMap[group.consultationStatus] || '--'}}</td>
            </tr>
            <tr>
              <td>咨询来源</td>
              <td>{{group.dataSourceName}}</td>
              <td>咨询人</td>
              <td>{{group.consultantName}}</td>
              <td>咨询人号码</td>
              <td>
                <div class="flex" style="    justify-content: space-between;align-items: center;">
                  <span>{{consultantTelPhone}}</span>

                  <Icon
                    :type="showMock?'md-eye-off':'md-eye'"
                    @click="viewTelPhone(group.promoterId)"
                    class="pointer"
                    size="20"
                    title="查看咨询人号码"
                    v-if="hasOperationRole || isAdmin"
                  ></Icon>

                  <Icon
                    @click="viewAllHis(group.promoterId)"
                    class="pointer"
                    size="20"
                    title="历史咨询"
                    type="md-time"
                    v-if="showHisIcon"
                  ></Icon>
                </div>
              </td>
            </tr>
            <tr>
              <td>咨询时间</td>
              <td>{{group.whenCreated}}</td>
              <td>接入时间</td>
              <td>{{group.acceptTime || '--'}}</td>
              <td>结束时间</td>
              <td>{{group.closeTime}}</td>
            </tr>
            <template v-if="group.consultationStatus == 'termination'">
              <tr>
                <td>备注</td>
                <td colspan="5">{{group.remark || '--'}}</td>
              </tr>
            </template>
            <template v-else>
              <tr>
                <template v-if="group.toManualTime">
                  <td>转人工时间</td>
                  <td>{{$moment(group.toManualTime).format('YYYY-MM-DD HH:mm:ss')}}</td>
                </template>
                <template v-else>
                  <td>服务律师</td>
                  <td>{{group.lawyerName || '--'}}</td>
                </template>
                <td>人工等待时长(秒)</td>
                <td>{{group.waitTime}}</td>
                <td>人工服务时长(秒)</td>
                <td>{{ group.consultationStatus =='finish'?group.serviceTime:'--'}}</td>
              </tr>
            </template>

            <tr>
              <td>业务类型</td>
              <td colspan="5">
                <Cascader
                  :data="spData"
                  @on-change="changedDicSpecialty"
                  filterable
                  trigger="hover"
                  v-model="spValue"
                />
              </td>
            </tr>
            <tr>
              <td>咨询标识</td>
              <td colspan="5">
                <template v-for="tag in tags">
                  <Tag
                    :color="tag.riskColor"
                    :key="tag.code + '-currentSelected'"
                    :name="tag.code"
                    v-if="currentTags.indexOf(tag.code) >= 0"
                  >{{tag.name}}</Tag>
                </template>

                <Button @click="handleOpen" ghost size="small" type="primary">
                  <Icon type="md-settings"></Icon>标识配置
                </Button>
              </td>
            </tr>

            <tr>
              <td>咨询内容</td>
              <td colspan="5">{{group.question}}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <template v-if="group.consultationStatus == 'finish'">
        <Divider orientation="left">满意度信息</Divider>
        <div class="satisfactionLogContainer">
          <div :class="satisfactionLog?.satisfactionResult+' satisfactionIcon'"></div>
          <template v-if="satisfactionLog">
            <table>
              <tr>
                <td>整体评价</td>
                <td :colspan="(subOpts.length * 2 -2)/2">{{satisfactionLog.satisfactionResultLabel}}</td>
                <td>数据来源</td>
                <td
                  :colspan="(subOpts.length * 2 -2)/2"
                >{{satisfactionLog.isDefaultValue?'系统默认':'咨询人评价'}}</td>
              </tr>
              <template
                v-if="satisfactionResultMap[satisfactionLog?.satisfactionResult]?.showSub && satisfactionLog.items"
              >
                <tr>
                  <template v-for="item in satisfactionLog.items">
                    <td
                      :key="item.evaluationDimension + 'evaluationDimensionLabel'"
                    >{{subOptsMap[item.evaluationDimension]}}</td>
                    <td
                      :key="item.evaluationDimension + 'evaluationDimension'"
                    >{{item.satisfactionResultLabel}}</td>
                  </template>
                </tr>
                <tr>
                  <td>问题</td>
                  <td
                    :colspan="subOpts.length * 2 -1"
                    style="text-align: left"
                  >{{satisfactionLog.remark}}</td>
                </tr>
              </template>
            </table>
          </template>
          <div class="textC" style="line-height: 4rem" v-else>暂无评价</div>
        </div>
      </template>
    </template>
    <template v-if="!group.effectively">
      <span class="unEffectively"></span>
    </template>
    <Divider orientation="left">咨询记录</Divider>
    <ul class="messageList" v-if="allHisMessages && allHisMessages.length > 0">
      <li :key="item.id+'-' + index + '-his'" v-for="(item, index) in allHisMessages">
        <messageInfoHis
          :message="item"
          :userInfo="allUserInfos[item.sendUserId]"
          class="allHisMessageItem"
        ></messageInfoHis>
      </li>
    </ul>
    <div class="textC" style="line-height: 4rem" v-else>暂无历史信息</div>
    <water-mark :opacity="0.4" v-if="showMask"></water-mark>

    <!-- </Modal> -->
    <Modal
      :mask-closable="false"
      :width="'900px'"
      @on-cancel="handleClose"
      title="咨询标识"
      v-model="visible"
    >
      <div style="max-height: 70vh; overflow-y: auto">
        <sunflower-table
          :columns="columnsTag"
          :opts="optsTag"
          :page="pageTag"
          ref="tagTable"
          v-if="visible"
        >
          <template slot="tableExtraContent">
            <div class="currentSelected">
              <span class="label">当前已选择【{{selectedTags.length}}】：</span>
              <template v-for="tag in tags">
                <Tag
                  :color="tag.riskColor"
                  :key="tag.code + '-currentSelected'"
                  :name="tag.code"
                  @on-close="closeTag"
                  closable
                  type="border"
                  v-if="selectedTags.indexOf(tag.code) >= 0"
                >{{tag.name}}</Tag>
              </template>
            </div>
          </template>
        </sunflower-table>
      </div>
      <template slot="footer">
        <Button @click="submitTag" size="small" type="primary">确定</Button>
        <Button @click="handleClose" size="small">取消</Button>
      </template>
    </Modal>
    <Modal footer-hide title="历史记录" v-model="showAllHis" width="90vw">
      <div style="max-height: 70vh; overflow-y: auto">
        <sunflower-table
          :columns="columns"
          :opts="opts"
          :page="page"
          :searchBoxForm="searchBoxForm"
          @addFunc="addFunc"
          ref="consultationTable"
          v-if="showAllHis"
        >
          <template slot="searchBoxForm">
            <Col :lg="8" :md="12" :sm="12" :xl="8" :xs="24" :xxl="6">
              <FormItem label="数据来源" prop="dataSource">
                <Select clearable filterable v-model="searchBoxForm.dataSource">
                  <Option
                    :key="item.code+'-dataSource'"
                    :value="item.code"
                    v-for="item in dataSources"
                  >{{ item.remark || item.code }}</Option>
                </Select>
              </FormItem>
            </Col>
            <Col :lg="8" :md="12" :sm="12" :xl="8" :xs="24" :xxl="6">
              <FormItem label="满意度信息" prop="satisfactionResults">
                <Select clearable filterable multiple v-model="searchBoxForm.satisfactionResults">
                  <template v-for="item in satisfactionResultOptions">
                    <Option
                      :key="item.value+'-satisfactionResult'"
                      :value="item.value"
                      v-if="(item.supportICTypes || []).indexOf('IM') >=0"
                    >{{ item.label }}</Option>
                  </template>
                </Select>
              </FormItem>
            </Col>
            <Col :lg="8" :md="12" :sm="12" :xl="8" :xs="24" :xxl="6">
              <FormItem label="接入类型" prop="distributionType">
                <Select clearable filterable v-model="searchBoxForm.distributionType">
                  <Option
                    :key="key+'-distributionType'"
                    :value="key"
                    v-for="(item, key) in $common.distributionTypes"
                  >{{ item.label }}</Option>
                </Select>
              </FormItem>
            </Col>

            <Col :lg="8" :md="12" :sm="12" :xl="8" :xs="24" :xxl="6">
              <FormItem label="是否接单" prop="accessed">
                <Select clearable filterable v-model="searchBoxForm.accessed">
                  <Option :value="0">否</Option>
                  <Option :value="1">是</Option>
                </Select>
              </FormItem>
            </Col>
            <Col :lg="8" :md="12" :sm="12" :xl="8" :xs="24" :xxl="6">
              <FormItem label="业务类型" prop="dicSpecialty">
                <Select clearable filterable v-model="searchBoxForm.dicSpecialty">
                  <Option :value="0">未填写</Option>
                  <Option :value="1">已填写</Option>
                </Select>
              </FormItem>
            </Col>
          </template>
          <template slot="tableBtnExt">
            <Button
              @click="openExportZip"
              size="small"
              type="primary"
              v-allow="hasOperationRole || isAdmin"
            >导出明细</Button>
          </template>
        </sunflower-table>
      </div>
    </Modal>

    <Modal @on-cancel="cancelExportZip" title="导出明细" v-model="exportZip">
      <Alert show-icon>请填写咨询件编码，多个编码以换行分隔。{{ rowCount }} 行</Alert>
      <Input
        :autosize="{minRows: 5,maxRows: 10}"
        @input="updateRowCount"
        placeholder="请填写咨询件编码"
        type="textarea"
        v-model="exportText"
      />
      <div slot="footer">
        <Button @click="exportData" type="primary">提交</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
import messageInfoHis from '@/components/IM-support/messageInfoHis'
export default {
  components: {
    messageInfoHis
  },
  props: {
    showSimple: {
      required: false,
      default: false
    },
    group: {},
    show: false,
    showMask: {
      required: false,
      default: true
    },
    showHisIcon: {
      required: false,
      default: false
    }
  },
  watch: {
    // show: {
    //   immediate: true,
    //   handler: function (val) {
    //     this.showHis = val
    //     if (this.showHis) {
    //       this.searchHis()
    //     }
    //   }
    // },
    group: {
      immediate: true,
      handler: function (val) {
        this.searchHis()
        this.consultantTelPhone = val.consultantTelPhone
        if (val?.consultationStatus == 'finish' && !this.showSimple) {
          this.getSatisfactionLog()
        }
        this.currentTags = this.group.tags || []
        this.spValue = Object.assign([], this.group.dicSpecialtyIds || [])
      }
    }
  },
  computed: {
    isAdmin: function () {
      return this.$store.getters['userInfo/isAdmin'] || false
    },
    systemRoles: function () {
      return (this.$store.getters['userInfo/user'] || {}).systemRoles || []
    },
    hasOperationRole: function () {
      return (this.systemRoles || []).indexOf('OPERATION_MANAGER') >= 0 || (this.systemRoles || []).indexOf('OPERATION') >= 0
    },
    opts: function () {
      return {
        autoSearch: false,
        labelWidth: 100,
        autoSearch: false,
        showAdd: false,
        searchUrl: this.$apis.ICIMApi.consultantApi.getFinishedList + '/' + this.group.promoterId,
        exportUrl: this.$apis.ICIMApi.consultantApi.exportFinished + '/' + this.group.promoterId,
        showMultiDel: false,
        showFilter: false,
        showSelection: true,
        showIndex: false
      }
    },
    columns: function () {
      let that = this
      let base = [{
        title: " ",
        searchable: false,
        align: "center",
        width: 18,
        key: "testData",
        className: 'noPadding',
        fixed: "left",
        render: (h, params) => {
          return h('div', {
            style: {
              display: params.row.testData ? '' : 'none',
              fontSize: '12px',
              color: 'red',
              fontWeight: 600,
              textAlign: 'center',
              padding: '2px',
              border: '1px solid',
              borderRadius: '4px',
              scale: 0.9
            }
          }, '测')
        }
      }, {
        title: "接入类型",
        align: "center",
        className: 'noPadding',
        key: "distributionType",
        fixed: 'left',
        minWidth: 90,
        render: (h, params) => {
          if (params.row.distributionType) {
            let type = this.$common.distributionTypes[params.row.distributionType] || {}
            return h('Tag', {
              props: { color: type.color, type: 'border' }
            }, type.label)
          }
          return ''
        }
      }, {
        title: "所属省份",
        align: "left",
        // fixed: "left",
        // sortable: 'custom',
        // sortType: 'desc',
        key: "provinceName",
        tooltip: true,
        width: 100,
      }, {
        title: "所属区域",
        align: "left",
        // fixed: "left",
        // sortable: 'custom',
        // sortType: 'desc',
        key: "areaName",
        tooltip: true,
        width: 100,
      }, {
        title: "咨询件编码",
        align: "left",
        key: "groupId",
        tooltip: true,
        minWidth: 180,
      },
      {
        title: "律师名称",
        align: "left",
        // fixed: 'left',
        // sortable: 'custom',
        // sortType: 'desc',
        key: "lawyerName",
        tooltip: true,
        minWidth: 120,
      },
      {
        title: "律师手机号",
        align: "left",
        // fixed: 'left',
        key: "telPhone",
        tooltip: true,
        minWidth: 130,
      },
      {
        title: "咨询人",
        align: "left",
        // fixed: 'left',
        key: "consultantName",
        tooltip: true,
        minWidth: 120
      },
      {
        title: "咨询人号码",
        align: "left",
        // fixed: 'left',
        key: "consultantTelPhone",
        tooltip: true,
        minWidth: 130
      },
      {
        title: "咨询类型",
        align: "left",
        // fixed: "left",
        // sortable: 'custom',
        key: "consultationTypeLabel",
        tooltip: true,
        minWidth: 120
      },
      {
        title: "服务主体",
        align: "left",
        // fixed: "left",
        // sortable: 'custom',
        key: "consultationSubjectLabel",
        tooltip: true,
        minWidth: 120
      },
      {
        title: "等待时长(秒)",
        align: "center",
        key: "waitTime",
        tooltip: true,
        minWidth: 120,
      },
      {
        title: "咨询时间",
        align: "right",
        key: "whenCreated",
        tooltip: true,
        minWidth: 180,
      },
      {
        title: "接入时间",
        align: "right",
        key: "acceptTime",
        tooltip: true,
        minWidth: 180,
      },

      {
        title: "结束时间",
        align: "right",
        key: "closeTime",
        tooltip: true,
        minWidth: 180,
      },
      {
        title: "咨询标识",
        align: "left",
        key: "tags",
        tooltip: true,
        minWidth: 160,
        render: (h, params) => {
          let arr = []
          if (params.row.tags && params.row.tags.length > 0) {
            this.tags.forEach(item => {
              if (params.row.tags.indexOf(item.code) >= 0) {
                arr.push(h('Tag', {
                  props: {
                    // type: 'border',
                    color: item.riskColor
                  }
                }, item.name))
              }
            })
          }
          return h('div', arr)

          //   return h('dicLabel', {
          //     props: {
          //       value: params.row.consultationSubject,
          //       category: 'CONSULTATION_SUBJECT'
          //     }
          //   })
        }
      },
      {
        title: "咨询内容",
        align: "left",
        key: "question",
        tooltip: true,
        minWidth: 260
      },
      {
        title: "咨询来源",
        align: "left",
        key: "dataSourceName",
        tooltip: true,
        minWidth: 150,
      },

      {
        title: "是否已评价",
        align: "center",
        key: "satisfactionEvaluated",
        tooltip: true,
        minWidth: 180,
        render: (h, params) => {
          return h('div', params.row.satisfactionEvaluated ? '是' : '否')
        }
      },
      {
        title: "满意度",
        align: "center",
        key: "satisfactionResult",
        tooltip: true,
        minWidth: 180,
        render: (h, params) => {
          let label = ''
          let arr = this.satisfactionResultOptions.filter(item => item.value == params.row.satisfactionResult)
          if (arr && arr.length > 0) label = arr[0].label
          return h('div', label)
        }
      },
      {
        title: "备注",
        align: "left",
        key: "remark",
        tooltip: true,
        minWidth: 180,
      }
      ]
      if (this.hasOperationRole || this.isAdmin) {
        base.push({
          title: "第三方编码",
          align: "left",
          key: "originalId",
          tooltip: true,
          minWidth: 180,
        })
      }
      return base
    }
  },
  data () {
    return {
      showMock: true,
      consultantTelPhone: '',
      rowCount: 0,
      exportText: '',
      exportZip: false,
      dataSources: [],
      satisfactionResultOptions: [],
      showAllHis: false,
      spData: [],
      visible: false,
      currentTags: [],
      selectedTags: [],
      tags: [],
      tagSearchKey: '',

      allHisMessages: [],
      allUserInfos: {},
      showHis: false,
      satisfactionLog: null,
      satisfactionOptions: [],
      satisfactionResultMap: {},
      subOptsMap: {
        // service: '服务态度',
        // efficiency: '效率',
        // environment: '环境',
        // ability: '能力',
        // honest: '廉洁',
        // other: '其它'
      },
      subOpts: [],
      pageTag: {
        pageSize: this.$common.page.pageSize,
        pageSizeOpts: this.$common.page.pageSizeOpts,
        total: 0,
        pageNo: 1,
        sorts: {}
      },
      optsTag: {
        flexSearchBox: false,
        size: 'small',
        showBtnExt: false,
        autoSearch: false,
        labelWidth: 60,
        showAdd: true,
        searchUrl: this.$apis.ICIMApi.config.getTagdList,
        showMultiDel: false,
        showFilter: true,
        showSelection: false,
        showIndex: true
      },
      columnsTag: [
        {
          title: "风险等级",
          align: "left",
          key: "riskLevel",
          tooltip: true,
          fixed: 'left',
          minWidth: 140,
          render: (h, params) => {
            let label = params.row.riskLevel
            let color = ''
            this.riskLevels.forEach(item => {
              if (item.value == params.row.riskLevel) {
                label = item.label
                color = item.color
              }
            })
            return h('Tag', {
              props: {
                color: color,
                type: "dot"
              }
            }, label)
          }
        },
        {
          title: "名称",
          align: "left",
          // fixed: "left",
          key: "name",
          tooltip: true,
          minWidth: 100
        },
        {
          title: "编码",
          align: "left",
          key: "code",
          tooltip: true,
          minWidth: 100
        },

        {
          title: "描述",
          align: "left",
          key: "remark",
          tooltip: true,
          minWidth: 140
        },
        {
          title: "操作",
          align: "left",
          width: 90,
          fixed: "center",
          render: (h, params) => {
            return h('div', [
              h('Button', {
                directives: [
                  {
                    name: 'allow',
                    value: this.$common.operatePermission.EDIT.key
                  }
                ],
                props: {
                  type: 'text',
                  size: 'small',
                },
                attrs: {
                  style: 'padding: 0; color: ' + (this.selectedTags.indexOf(params.row.code) >= 0 ? '#ff9900' : '#009EFC') + '!important; ',
                },
                on: {
                  'click': (e) => {
                    this.editTag(params.row.code)
                  }
                },
              }, this.selectedTags.indexOf(params.row.code) >= 0 ? '取消' : '添加'),
            ])
          }
        }
      ],
      riskLevels: [],
      spValue: [],
      searchBoxForm: {
        satisfactionResults: [],
        consultationType: null,
        consultationSubject: null,
        consultantTimes: ''
      },
      page: {
        pageSize: this.$common.page.pageSize,
        pageSizeOpts: this.$common.page.pageSizeOpts,
        total: 0,
        pageNo: 1,
        sorts: {}
      },

    }
  },
  methods: {
    viewTelPhone: function (id) {
      this.showMock = !this.showMock
      if (this.showMock) {
        this.consultantTelPhone = this.group.consultantTelPhone
      } else {
        let arr = id.split("_")
        this.consultantTelPhone = arr[arr.length - 1]

      }
    },
    addFunc: function (type, data) {
      switch (type) {
        case 'reset':
          this.searchBoxForm = {
            satisfactionResults: [],
            consultationType: null,
            consultationSubject: null,
            consultantTimes: [],
            consultantTimeStart: null,
            consultantTimeEnd: null
          }
          break
      }
    },
    openExportZip: function () {
      let select = this.$refs.consultationTable.selected
      if (select == undefined || select.length == 0) {
        this.exportZip = true
        this.exportText = ''
        this.rowCount = 0
      } else {
        const items = []
        select.forEach(item => {
          items.push(item.groupId)
        })
        let content = `请确认是否导出选中的${select.length}条数据明细！`
        if (select.length > 100) {
          this.$Message.warning({ content: '当前记录超过100条，请添加筛选条件后下载！', duration: 5 })
          return
        }
        this.$Modal.confirm({
          title: '提醒',
          content: content,
          okText: '导出',
          onOk: () => {
            this.downloadZip(items)
          }
        })
      }
    },
    cancelExportZip: function () {
      this.exportZip = false
      this.exportText = ''
      this.rowCount = 0
    },
    updateRowCount () {
      this.rowCount = this.exportText.split('\n').length
    },
    exportData: function () {
      let that = this
      const items = this.exportText.split('\n').filter(item => item.trim().length > 0).map(item => item.trim())
      if (!that.isAdmin && that.rowCount > 100) {
        that.$Message.error("咨询编码不得超过100个")
        return false
      }
      if (items.length <= 0) {
        that.$Message.error("咨询编码不得为空")
        return false
      }
      that.downloadZip(items)
    },
    downloadZip: function (groupIds) {
      let that = this
      this.$Spin.show({
        render: (h) => {
          return h('div', [
            h('Icon', {
              'class': 'demo-spin-icon-load',
              props: {
                type: 'ios-loading',
                size: 18
              }
            }),
            h('div', '文件下载中，请稍候...')
          ])
        }
      })
      that.$axios.post(this.$apis.ICIMApi.consultantApi.exportFinishedZip, groupIds, { responseType: 'blob' }).then(val => {
        let url = window.URL.createObjectURL(new Blob([val.data]))
        let link = document.createElement('a')
        link.id = "mocDownload"
        link.style.display = 'none'
        link.href = url
        link.setAttribute('download', "即时咨询件明细" + that.$common.nowYMDHMS() + ".zip")
        document.body.appendChild(link)
        link.click()
        window.URL.revokeObjectURL(link.href)
        document.body.removeChild(link)
      }).catch(err => {
        console.log(err)
        that.$Message.error("导出ZIP文件失败")
      }).finally(() => {
        setTimeout(() => {
          that.$Spin.hide()
          that.cancelExportZip()
        }, 1000)
      })
    },
    getDataSourceOptions: async function () {
      let params = new this.$URLSearchParams()
      params.append("icTypeCode", "IM")
      this.dataSources = await this.$baseData.handleData(true, this.$apis.projectManagementApi.getDataSourceOptions, params)
    },
    initSpData: async function () {
      this.spData = await this.$baseData.handleData(false, this.$apis.dictionaryManager.specialty.getFullTree, null) || []
    },
    getRiskLevels: function () {
      let that = this
      this.$axios.post(that.$apis.ICIMApi.getRiskLevels).then(res => {
        if (res.success) {
          that.riskLevels = res.result || []
        } else {
          that.$Message.error(res.message)
        }
      }).catch(function (err) {
        console.log(err)
        that.$Message.error("获取风险等级选项失败！")
      })
    },
    changeTags: function (val) {
      console.log('changeTags', val)
      this.currentTags = val
    },
    closeTag: function (e, name) {
      console.log(e, name)
      let index = this.selectedTags.indexOf(name)
      if (index !== -1) {
        this.selectedTags.splice(index, 1)
      }
    },
    editTag: function (name) {
      let index = this.selectedTags.indexOf(name)
      if (index !== -1) {
        this.selectedTags.splice(index, 1)
      } else {
        this.selectedTags.push(name)
      }
    },
    handleOpen () {
      this.selectedTags = Object.assign([], this.currentTags)
      this.visible = true
    },
    handleClose () {
      this.visible = false
      this.selectedTags = []
    },
    submitTag: function () {
      let that = this
      // let params = new this.$URLSearchParams()
      // params.append('consultationId', this.chartGroup.id)
      // params.append('tags', this.currentTags)
      let params = {
        'id': this.group.id,
        'tags': this.selectedTags
      }
      this.$axios.post(that.$apis.ICIMApi.submitTag, params).then(res => {
        if (res.success) {
          that.$Message.success('操作成功！')
          that.currentTags = Object.assign([], res.result?.tags)
          that.handleClose()
        } else {
          that.$Message.error(res.message)
        }
      }).catch(function (err) {
        that.$Message.error('提交标识失败！')
      })
    },
    initTags: function () {
      let that = this
      that.$axios.post(this.$apis.ICIMApi.getTagOptions).then(res => {
        if (res.success) {
          that.tags = res.result || []
        } else {
          that.$Message.error(res.message)
        }
      }).catch(function (err) {
        that.$Message.error("获取标识列表失败！")
      })
    },
    searchHis: function () {
      let that = this
      this.allHisMessages = []
      this.allUserInfos = []
      this.showHis = true
      let params = new this.$URLSearchParams()
      params.append("groupId", this.group.groupId)
      this.$axios.post(that.$apis.ICIMApi.getIMHistory, params).then(res => {
        if (res.success) {
          that.allHisMessages = res.result?.hisMessages || []
          that.allUserInfos = res.result?.userInfos || {}
        } else {
          that.$Message.error(res.message)
        }
      }).catch(function (err) {
        that.$Message.error('获取历史消息失败！')
      })
    },
    getSatisfactionLog: function () {
      let that = this
      this.satisfactionLog = null
      let params = new this.$URLSearchParams()
      params.append("icType", "IM")
      params.append("consultationId", this.group.id)
      this.$axios.post(that.$apis.common.satisfactionLog, params).then(res => {
        if (res.success) {
          that.satisfactionLog = res.result
        } else {
          that.$Message.error(res.message)
        }
      }).catch(function (err) {
        that.$Message.error('获取满意度信息失败！')
      })
    },
    cancelHis: function () {
      this.allHisMessages = []
      this.allUserInfos = {}
      this.handleClose()
      this.$emit('cancelHis')
    },
    changedDicSpecialty: function (value, selectedData) {
      if (value == null || value == undefined || value.length == 0) {
        this.$Message.warning({
          content: '请选择业务类型！',
          duration: 3
        })
      } else {
        let that = this
        let param = {
          id: this.group?.id,
          dicSpecialtyIds: value
        }
        this.$axios.post(that.$apis.ICIMApi.modifyDicSpecialty, param).then(res => {
          if (res.success) {
            that.$Message.success({ content: '修改成功！', duration: 3 })
            that.group.dicSpecialtyIds = value
            that.$emit('dataChange')
          } else {
            that.$Message.error(res.message)
          }
        }).catch(function (err) {
          that.$Message.error('修改业务类型失败！')
        })
      }
    },

    changeCT: function (val) {
      if (val) {
        let that = this
        let param = {
          id: this.group?.id,
          consultationType: val
        }
        this.$axios.post(that.$apis.ICIMApi.modifyConsultationType, param).then(res => {
          if (res.success) {
            that.$Message.success({ content: '修改成功！', duration: 3 })
            that.group.consultationType = val
            that.$emit('dataChange')
          } else {
            that.$Message.error({
              content: res.message,
              duration: 3
            })
          }
        }).catch(function (err) {
          that.$Message.error({
            content: '修改咨询类型失败！',
            duration: 3
          })
        })
      } else {
        this.$Message.warning({
          content: '请选择咨询类型！',
          duration: 3
        })
      }
    },
    loadSatisfactionResults: async function () {
      this.satisfactionOptions = await this.$baseData.handleData(false, this.$apis.common.satisfactionResultOptions, null) || []
      this.satisfactionOptions.forEach(item => {
        this.satisfactionResultMap[item.value] = item
      })
    },
    evaluationDimensionOptions: async function () {
      this.subOpts = await this.$baseData.handleData(false, this.$apis.common.evaluationDimensionOptions, null) || []
      this.subOpts.forEach(item => {
        this.subOptsMap[item.value] = item.label
      })
    },
    viewAllHis: function (promoterId) {
      this.showAllHis = true
    }

  },
  beforeMount () {
    this.getDataSourceOptions()
    this.loadSatisfactionResults()
    this.evaluationDimensionOptions()
    this.initSpData()
    this.getRiskLevels()
    this.initTags()
  }
}
</script>

<style lang="less" scoped>
.chartInfo {
  position: relative;
  margin-bottom: 10px;
  table {
    width: 100%;
    table-layout: auto;
    border-collapse: collapse;
    tr {
      td {
        border: 1px solid #e8e9ec;
        padding: 10px;
      }
      > td:nth-child(odd) {
        white-space: nowrap;
      }
    }
  }
}

.messageList {
  background-color: #f9f9f9;
  list-style: none;
}

.satisfactionLogContainer {
  position: relative;
  margin-bottom: 10px;

  table {
    max-width: 100%;
    width: 100%;
    table-layout: auto;
    border-collapse: collapse;
    tr {
      td {
        border: 1px solid #e8e9ec;
        padding: 10px;
        text-align: center;
      }

      td:nth-child(odd) {
        background-color: #f9f9f9;
        // white-space: nowrap;
      }
    }
  }
}

.filterContianer {
  padding: 10px;
}

.currentSelected {
  font-size: 0.8rem;
  color: #888;
  padding-bottom: 0.5rem;
  border-bottom: 1px dashed #eee;
  margin-bottom: 0.5rem;
}

.tagSelectBtn {
  text-align: right;
  border-top: 1px solid #eee;
  padding: 4px;
}
</style>
